import React from 'react';
import Calculator from './components/Calculator';

const App = () => {
  return <Calculator />;
};

export default App;
